<template>
    <div v-tippy="$t('text-likes')" class="flex flex-row items-center space-x-0.5 cursor-pointer" @click="toggle">
        <HeartSolid v-if="variant.isInCustomerLikes || variant.isInVisitorLikes" :class="[ 'w-4 h-4', accent ? 'text-card-icon hover:text-card-icon-hover' : 'text-primary-dark hover:text-primary-dark-hover' ]" />
        <Heart v-else :class="[ 'w-4 h-4', accent ? 'text-card-icon hover:text-card-icon-hover' : 'text-primary-dark hover:text-primary-dark-hover' ]" />
        <div v-if="variant.likesCount" :class="[ 'text-xs font-normal', accent ? 'text-light hover:text-light-hover' : 'text-primary-dark hover:text-primary-dark-hover' ]">
            {{ variant.likesCount }}
        </div>
        <div v-if="label" :class="[ 'text-xs font-normal pr-5', accent ? 'text-light hover:text-light-hover' : 'text-primary-dark hover:text-primary-dark-hover' ]">
            {{ $t(label) }}
        </div>
    </div>
</template>

<script setup>
import { API_ENDPOINTS } from "@utils/api/endpoints";
import Heart from "@components/icons/outline/heart";
import HeartSolid from "@components/icons/solid/heart-solid";

const props = defineProps({
  variant: {
    type: Object,
    default: () => {}
  },
  label: {
    type: String,
    default: null
  },
  accent: {
    type: Boolean,
    default: false
  }
});

const { t } = useI18n();
const { $eventBus, $toast } = useNuxtApp();
const activityChecker = useActivityChecker();
const loading = ref(false);

const toggle = async () => {
  if (loading.value || (!activityChecker.wasUserActive.value && !checkAuth())) {
      return;
  }
  loading.value = true;
  const { data, error, status } = await useApiFetch(API_ENDPOINTS.CONTENT_POST_ID_LIKE, {
    method: props.variant.isInCustomerLikes || props.variant.isInVisitorLikes ? 'DELETE' : 'POST',
    path: {
      idPost: props.variant.id
    }
  });
  if (status.value === 'error') {
    if (import.meta.client) {
      $toast.error(t('error.content-detail.likes'));
    }
    sentryCaptureEvent({
      message: 'content-likes.toggle',
      level: 'error',
      extra: { error: error.value }
    });
  } else {
    $eventBus.emit('content:update', data.value);
  }
  loading.value = false;
}

</script>
